module.exports = __webpack_public_path__ + "d6413ba1/img/comment-question-icon.7dd26e04.svg";